<template>
  <div
    class="shadow"
    v-loading="flag"
    element-loading-text="正在上传资源中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  ></div>
</template>
<script>
import * as THREE from "three/build/three.module";
import Bus from "../../common/js/bus";
import axios from "axios";
export default {
  props: ["viewHeight", "itemName", "floor", "speed", "ios"],
  data() {
    return { flag: false, bAdminView: false };
  },
  mounted() {
    var that = this;

    Bus.$on("flag", (target) => {
      that.flag = target;
    });
    Bus.$on("stream", (target) => {
      console.log(target);
      if (target[0] == "local_stream") {
        document.o2.onLocalStreamAdd();
      } else {
        document.o2.onRemoteStreamAdd(target[1]);
      }
    });
    //拖拽
    Bus.$on("drag", (event) => {
      var that = this;
      if (event.size > 102400000) {
        this.$notify({
          title: "警告",
          message: "文件过大",
          type: "warning",
        });
      } else {
        this.$o2Function.getMD5(event, function (md5) {
          // console.log(md5); //hash值
          let formData = new FormData();
          formData.append("md5", md5);
          axios
            .post("https://o2vr.net/UserSig/php/media_exist.php?", formData, {
              "Content-Type": "multipart/form-data",
            })
            .then((res) => {
              if (res.data.code == 1) {
                that.flag = true;
                let formData = new FormData();
                formData.append("file", event);
                axios
                  .post("https://o2vr.net/UserSig/php/media_upload.php", formData, {
                    "Content-Type": "multipart/form-data",
                  })
                  .then((res) => {
                    that.flag = false;
                    console.log(res.data.rid);
                    screen_url(res.data.rid);
                  });
              } else {
                console.log(res.data.rid);
                screen_url(res.data.rid);
              }
            });
        });
      }
    });
    //主持人模式
    Bus.$on("admin_mode", (e) => {
      console.log(e, "主持人模式开关");
      that.bAdminView = e;

      if (admin_mode) {
        let str = "share_view," + e;
        if (ws) {
          ws.send(str);
        }
      }
    });
    ///主持人模式
    var old_screen_url;
    var admin_mode = false;
    var scene_state = {}; //场景状态
    /////////////
    var down_speed = 0;
    var colli;
    var colli_height = 200;
    var last_click_pos = new THREE.Vector2();
    var last_click_time;
    var bCtrlStop = false;
    let old_pos, old_eye;
    var touch_time;
    var last_case_id = 0;
    var ws;
    let target_angle = 0;
    let ground_height = 0;
    let last_clip_name;
    let posPlayer = new THREE.Vector3();
    let startPos = new THREE.Vector3();
    let endPos = new THREE.Vector3();
    let mouse = new THREE.Vector2();
    var viewHeight = this.viewHeight;
    var itemName = this.itemName;
    var floor = this.floor;
    var player_name = "";
    var room_id = 0;
    var ws_pos_cold_down = 0;
    var player_id = 0;
    var bLoginSuccess = false;
    var last_pos_send;
    var last_cam_send;
    console.log(floor);

    //视角分享
    // var bAdminView = false; //跟随支持人
    var admin_old_pos;
    var admin_old_eye;
    var admin_target_pos = new THREE.Vector3();
    var admin_target_eye = new THREE.Vector3();
    var admin_move_time;
    var admin_angle_old;
    var admin_angle_new;
    var last_walk;

    /////项目介绍板
    var project_urls = [];
    for (let i = 1; i <= 15; i++) {
      project_urls.push("https://o2vr.net/res/demos/" + i + ".jpg");
    }
    project_urls[2] = "https://o2vr.net/res/demos/xnkl.jpg";
    var projects_parent;
    var project_objects = [];

    var moveSpd = this.speed;
    if (!moveSpd) moveSpd = 3000;
    if (!viewHeight) {
      viewHeight = 2000;
    }
    if (!itemName) {
      itemName = "Item";
    }
    var _o2 = document.o2;
    var bKeyCtrl = true;
    var bAutoMove = false;
    var targetAutoMove = new THREE.Vector3();

    var moveDir = new THREE.Vector3();
    var that = this;
    function onMouseDown(event) {
      touch_time = Date.now();
    }
    function Base64() {
      // private property
      var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

      // public method for encoding
      this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = _utf8_encode(input);
        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }
          output =
            output +
            _keyStr.charAt(enc1) +
            _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) +
            _keyStr.charAt(enc4);
        }
        return output;
      };
      // public method for decoding
      this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }
        output = _utf8_decode(output);
        return output;
      };

      // private method for UTF-8 encoding
      let _utf8_encode = function (string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
            utftext += String.fromCharCode(c);
          } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
          } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
          }
        }
        return utftext;
      };

      // private method for UTF-8 decoding
      let _utf8_decode = function (utftext) {
        var string = "";
        var i = 0;
        let c2 = 0;
        let c1 = 0;
        let c3 = 0;
        var c = (c1 = c2 = 0);
        while (i < utftext.length) {
          c = utftext.charCodeAt(i);
          if (c < 128) {
            string += String.fromCharCode(c);
            i++;
          } else if (c > 191 && c < 224) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
          } else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(
              ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
            );
            i += 3;
          }
        }
        return string;
      };
    }
    function send_camera_to_server(bForce) {
      if (!ws || !bLoginSuccess) return;
      let str = "cam," + getView();
      if (str != last_cam_send) {
        console.log(str);
        last_cam_send = str;
        ws.send(str);
      } else {
        if (bForce) {
          console.log(str);
          last_cam_send = str;
          ws.send(str);
        }
      }
    }
    function send_position_to_server(bForce) {
      if (!ws || !bLoginSuccess) return;
      let angle2 = Math.ceil((target_angle * 180) / 3.1415);
      let str =
        "pos," + Math.ceil(posPlayer.x) + "," + Math.ceil(posPlayer.z) + "," + angle2;
      if (str != last_pos_send) {
        console.log(str);
        last_pos_send = str;
        ws.send(str);
      } else {
        if (bForce) {
          console.log(str);
          last_pos_send = str;
          ws.send(str);
        }
      }
    }
    function hot_clicked(name) {
      console.log("hot_clicked:", name);
    }
    function stop_ctrl(bStop) {
      if (bCtrlStop == bStop) return;
      if (!bCtrlStop) {
        old_pos = _o2.cameraControls.target.clone();
        old_eye = _o2.camera.position.clone();
      } else {
        _o2.cameraControls.target.set(old_pos.x, old_pos.y, old_pos.z);
        _o2.camera.position.set(old_eye.x, old_eye.y, old_eye.z);
      }
      bCtrlStop = bStop;
    }
    _o2.stop_ctrl = stop_ctrl;
    function board_cast_state() {
      let msgstr = JSON.stringify(scene_state);
      msgstr = "state," + msgstr;
      ws.send(msgstr);
    }
    function on_scene_state_changed() {
      if (admin_mode) board_cast_state();
    }
    function active_software(name) {
      let sw = 0;
      if (name == "hot_software1") sw = 1;
      if (name == "hot_software2") sw = 2;
      if (name == "hot_software3") sw = 3;
      if (name == "hot_software4") sw = 4;
      scene_state.software = sw;
      on_scene_state_changed();
      // _o2.software1.LoopType = 2;
      // _o2.software2.LoopType = 2;
      // _o2.software3.LoopType = 2;
      // _o2.software4.LoopType = 2;
      // if (name == "hot_software1") _o2.software1.LoopType = 0;
      // if (name == "hot_software2") _o2.software2.LoopType = 0;
      // if (name == "hot_software3") _o2.software3.LoopType = 0;
      // if (name == "hot_software4") _o2.software4.LoopType = 0;
      // _o2.software2.play();
      // _o2.software1.play();
      // _o2.software3.play();
      // _o2.software4.play();
    }
    _o2.active_software = active_software;
    function onItemClick(intersect) {
      console.log("onItemClick", intersect);
      let object = intersect.object;
      //判断地面
      let bGround = false;
      if (object.name == "" && object.parent.name == "ground") bGround = true;
      if (object.name == "ground1" || object.name == "ground2") bGround = true;
      if (bGround) {
        move_to(intersect.point.x, intersect.point.z);
      }
      Bus.$emit("onItemClick", object.name);
      let name = object.name;
      //关闭视频
      if (object.name == "Plane026#") {
        _o2.screen_url(null);
      }
      //案例墙
      if (object.case_url) {
        scene_state.case_id = object.case_id;
        on_scene_state_changed();
      }
      //点击案例
      if (object == _o2.case_screen && object.case && object.case.video) {
        screen_url(object.case.video);
        return;
      }
      //软件热点
      if (
        name == "hot_software1" ||
        name == "hot_software2" ||
        name == "hot_software3" ||
        name == "hot_software4"
      ) {
        active_software(name);
        hot_clicked(name);
      }
      //地球打开
      if (name == "hot_earth") {
        if (scene_state.earth_open == null) scene_state.earth_open = true;
        else scene_state.earth_open = !scene_state.earth_open;
        on_scene_state_changed();
      }
    }
    function send_click_msg() {
      if (!ws || !bLoginSuccess) return;
      if (!admin_mode) return;
      let str_pos =
        "click," +
        Math.round(_o2.click.position.x) +
        "," +
        Math.round(_o2.click.position.y) +
        "," +
        Math.round(_o2.click.position.z);
      ws.send(str_pos);
    }
    function getMovePoint(intersect) {
      if (that.flag) return;
      let _o2 = document.o2;
      let pos = intersect.position;
      return pos;
    }
    function onMouseUp(event) {
      // if (that.flag) return;
      let _o2 = document.o2;

      let dnow = Date.now();
      let dst = dnow - touch_time;
      if (dst > 200) {
        return;
      }
      //双击判断
      {
        if (last_click_time) {
          let offset = new THREE.Vector2();
          offset.set(event.offsetX, event.offsetY);
          let dst2 = dnow - last_click_time;
          offset.sub(last_click_pos);
          let len = offset.length();
          console.log("dbtest,", len, dst2);
          if (len < 100 && dst2 < 500) {
            //点击点
            if (_o2.click) {
              let intersects = _o2.ray_test(event);
              if (intersects.length > 0) {
                let intersect = intersects[0];
                _o2.click.position.set(
                  intersect.point.x,
                  intersect.point.y,
                  intersect.point.z
                );
                _o2.click.visible = true;
                _o2.click.click_life = 3;
                send_click_msg();
              }
            }

            last_click_time = null;
            return;
          }
        }
      }
      last_click_pos.set(event.offsetX, event.offsetY);
      last_click_time = dnow;
      let intersects = _o2.ray_test(event);
      if (intersects.length > 0) {
        onItemClick(intersects[0]);
      }
    }
    function init_player_char(obj, arr) {
      if (obj) {
        for (let i = 0; i < obj.children.length; i++) {
          let child = obj.children[i];
          if (child.name.indexOf("Hair") >= 0 && arr[0] != "undefined") {
            let idx = parseInt(child.name.substr(5, child.name.length - 5));
            child.visible = idx == arr[0];
          }
          if (child.name.indexOf("Glasses") >= 0 && arr[1] != "undefined") {
            let idx = parseInt(child.name.substr(8, child.name.length - 8));
            child.visible = idx == arr[1];
          }
        }
      }
    }
    function on_ws_click(str) {
      var postr = str.split(",");
      if (_o2.click) {
        _o2.click.position.set(
          parseInt(postr[0]),
          parseInt(postr[1]),
          parseInt(postr[2])
        );
        _o2.click.visible = true;
        _o2.click.click_life = 3;
      }
    }
    function setView(str) {
      var view = str.split(",");
      admin_old_eye = _o2.camera.position.clone();
      if (!admin_old_pos)
        posPlayer.set(parseInt(view[3]), parseInt(view[4]), parseInt(view[5]));
      admin_old_pos = posPlayer.clone();
      if (!admin_target_pos) admin_target_pos = new THREE.Vector3();
      if (!admin_target_eye) admin_target_eye = new THREE.Vector3();
      admin_move_time = Date.now();
      admin_target_eye.set(parseInt(view[0]), parseInt(view[1]), parseInt(view[2]));
      admin_target_pos.set(parseInt(view[3]), parseInt(view[4]), parseInt(view[5]));
      admin_angle_old = _o2.player.rotation.y;
      admin_angle_new = (parseInt(view[6]) / 180) * 3.1416;

      let dst = (admin_angle_new * 180) / 3.1415 - (admin_angle_old * 180) / 3.1415;
      if (Math.abs(dst) > 180) {
        if (dst < 0) admin_angle_old = admin_angle_old - 3.1415 * 2;
        else admin_angle_old = admin_angle_old + 3.1415 * 2;
      }
    }
    function getView() {
      return (
        Math.round(_o2.camera.position.x) +
        "," +
        Math.round(_o2.camera.position.y) +
        "," +
        Math.round(_o2.camera.position.z) +
        "," +
        Math.round(posPlayer.x) +
        "," +
        Math.round(posPlayer.y) +
        "," +
        Math.round(posPlayer.z) +
        "," +
        Math.round((_o2.player.rotation.y * 180) / 3.1416)
      );
    }

    function add_player(id, name, num, cfg) {
      //Bus派发num给展厅
      Bus.$emit("num", 1);
      let url = _o2.char_urls[num];
      console.log(url);
      // alert(url);
      let promise = _o2.import_object_url(url);
      // let promise = _o2.import_object_url("https://o2vr.net/players/man2.zip");

      promise.then((obj3) => {
        if (obj3) {
          obj3.visible = false; //先隐藏，第一次有位置以后再出现
          obj3.name = toString(id);
          _o2.renew_all_uuid(obj3);
          if (!_o2.players) {
            _o2.players_object = new THREE.Object3D();
            _o2.players = [];
            _o2.scene.add(_o2.players_object);
          }
          _o2.players_object.add(obj3);
          let player = {};
          player.object = obj3;
          player.id = id;

          var base = new Base64();
          player.name = base.decode(name);
          for (let i = 0; i < obj3.children.length; i++) {
            if (obj3.children[i].type == "Group") {
              player.char = obj3.children[i];
              break;
            }
          }
          _o2.add_lable_to_char(obj3, player.name);
          //_o2.add_video_stream_to_char(obj3,player.name);
          player.target = new THREE.Vector3();
          _o2.players.push(player);
          console.log("new_player", player);
          send_position_to_server(1);
        }
      });
    }
    function update_player_position(id_player, posx, posz, angle) {
      for (let i = 0; i < _o2.players.length; i++) {
        let player = _o2.players[i];
        if (player.id == id_player && player.object) {
          player.target.x = posx;
          player.target.z = posz;
          player.target.y = (angle * 3.1415) / 180;
          if (!player.object.visible) {
            player.object.visible = true;
            player.object.position.set(posx, ground_height, posz);
          }
        }
      }
    }
    function move_to(x, y) {
      bAutoMove = true;
      targetAutoMove.x = x;
      targetAutoMove.y = ground_height;
      targetAutoMove.z = y;
    }
    function remove_player(id) {
      if (_o2.players) {
        let left_players = [];
        for (let i = 0; i < _o2.players.length; i++) {
          let player = _o2.players[i];
          if (player.id == id) {
            _o2.players_object.remove(player.object);
          } else {
            left_players.push(player);
          }
        }
        _o2.players = left_players;
      }
    }

    function prepare_cases() {
      var xhr = new XMLHttpRequest();
      xhr.open("get", "https://o2vr.net/res/cases/case.json", true);
      xhr.responseType = "text";
      xhr.onload = function () {
        if (this.status == 200) {
          var xxx = JSON.parse(this.response);

          console.log(xxx);
          // console.log(xxx);

          // var xxx = [
          //   {
          //     img: "https://o2vr.net/upload/img/1.png",
          //     url: "http://o2vr.net/upload/O2VRBMW/warehouse/#/",
          //   },
          //   {
          //     img: "https://o2vr.net/upload/img/2.png",
          //     url: "http://o2vr.net/upload/O2VRBMW/warehouse/#/",
          //   },
          //   {
          //     img: "https://o2vr.net/upload/img/3.png",
          //     url: "http://o2vr.net/upload/O2VRBMW/warehouse/#/",
          //   },
          //   {
          //     img: "https://o2vr.net/upload/img/4.png",
          //     url: "http://o2vr.net/upload/O2VRBMW/warehouse/#/",
          //   },
          // ];
          //创建DEMO列表板
          for (let i = 0; i < xxx.length; i++) {
            let obj = xxx[i];
            let url = "https://o2vr.net/res/cases/" + obj.img;
            // let url = obj.img;
            let map = _o2.create_map(url);
            if (map) {
              var geometry = new THREE.PlaneGeometry(1600, 900);
              var material = new THREE.MeshPhongMaterial({
                color: 0xffffff,
                side: THREE.DoubleSide,
              });
              material.map = map;
              material.lightMap = _o2.map_white;
              var plane = new THREE.Mesh(geometry, material);
              let dz = Math.random() * 2000;
              let dx = Math.random() * 1000 - 800;
              dz = dx = 0;
              dz = 300;
              plane.position.set(dx, -i * 2000, -4023 + dz);
              projects_parent.add(plane);
              let scale = Math.random() * 0.5 + 1;
              scale = 2;
              plane.scale.set(scale, scale, scale);
              project_objects.push(plane);
              plane.case_url = url;
              plane.case_id = i + 1;
              plane.case = obj;
              plane.basey = plane.position.y;
            }
          }
        }
      };
      xhr.send();
    }

    _o2.move_to = move_to;
    function init() {
      prepare_cases();
      _o2.stop_switch_camera();
      // _o2.cameraControls.target.set(-190, 2163, -1106);
      // _o2.camera.position.set(-413, 2554, -8251);
      // projects_parent = new THREE.Object3D();
      // _o2.scene.add(projects_parent);
      // colli = _o2.search_obj_by_name("colli");
      // posPlayer.set(0, 0, 0);
      // move_to(0, 0);
      _o2.cameraControls.target.set(-190, 2163, -1106);

      _o2.camera.position.set(715, 1657, -3049);
      projects_parent = new THREE.Object3D();
      _o2.scene.add(projects_parent);
      colli = _o2.search_obj_by_name("colli");
      posPlayer.set(0, 0, 0);
    }

    function move_with_colli(target, time_passed) {
      if (!colli) {
        posPlayer.set(target.x, target.y, target.z);
        return;
      }
      let radius = 200;
      let final = posPlayer.clone();
      let org = posPlayer.clone();
      org.y += colli_height;
      let target2 = target.clone();
      target2.y += colli_height;
      let dst = target2.clone();
      dst.sub(org);
      let len = dst.length() + radius;
      let raycaster = new THREE.Raycaster();
      raycaster.far = 1000;
      let dir = dst.clone();
      dir.normalize();
      org.sub(dir);
      raycaster.set(org, dir);
      var intersects = raycaster.intersectObjects(colli.children, true);
      if (intersects.length > 0) {
        if (intersects[0].distance < len) {
          dir.multiplyScalar(intersects[0].distance - radius);
          final.add(dir); //现在是退回到被拦截的位置，下面需要从切线方向滑行
          //滑行碰撞检测
          dir.normalize();
          let normal = intersects[0].face.normal.clone();
          normal.applyEuler(intersects[0].object.rotation);
          let spit = new THREE.Vector3(0, 1, 0);
          spit.cross(normal);
          spit.normalize();
          if (spit.dot(dir) < 0) spit = spit.multiplyScalar(-1); //旋转方向至行走方向的一边
          let len1 = dst.dot(spit);
          let len_final = len1 + radius;
          raycaster.set(org, spit);
          let intersects3 = raycaster.intersectObjects(colli.children, true);
          if (intersects3.length) {
            if (intersects[0].distance < len_final) {
              spit.multiplyScalar(intersects[0].distance - radius);
              final.add(spit);
            } else {
              spit.multiplyScalar(len_final - radius);
              final.add(spit);
            }
          } else {
            spit.multiplyScalar(len_final - radius);
            final.add(spit);
          }
        } else {
          final.set(target.x, posPlayer.y, target.z);
        }
      } else {
        final.set(target.x, posPlayer.y, target.z);
      }

      //下落
      down_speed = down_speed + 9800 * time_passed;
      let down_length = down_speed * time_passed;
      org.set(org.x, posPlayer.y + 500, org.z);
      dir.set(0, -1, 0);
      let y = posPlayer.y - down_length;
      let raycaster2 = new THREE.Raycaster();
      raycaster2.far = 1000;
      raycaster2.set(org, dir);
      intersects = raycaster2.intersectObjects(colli.children, true);
      if (intersects.length > 0) {
        //有碰撞到
        let pos = intersects[0].point;
        if (intersects[0].distance < 500 + down_length) {
          down_speed = 0;
          let dst = pos.y - posPlayer.y;
          if (dst < colli_height) {
            y = pos.y;
          }
        }
      }
      if (y < 0) {
        //落到了0平面
        y = 0;
        down_speed = 0;
      }
      final.y = y;
      posPlayer.set(final.x, final.y, final.z);
    }
    function on_ws_state(state) {
      scene_state = state;
    }
    _o2.init_play = init;
    function WebSocketInit() {
      if ("WebSocket" in window) {
        console.log("support WebSocket!");
        ws.onopen = function () {
          console.log("WebSocket OnOpen...");
        };
        ws.onmessage = function (evt) {
          console.log(evt);
          var received_msg = evt.data;
          console.log(received_msg);
          let pos = received_msg.indexOf(",");
          if (pos > 0) {
            let cmd = received_msg.substr(0, pos);
            let param = received_msg.substr(pos + 1, received_msg.length - pos - 1);
            //console.log(cmd,param);
            if (cmd == "logsuccess") {
              player_id = parseInt(param);
              if (_o2.player) {
                _o2.player.visible = true;
                //if (_o2.role_id == role_id) {
                //_o2.add_lable_to_char(_o2.player, player_name);
                //} else {
                _o2.role_id = role_id;
                for (let i = 0; i < _o2.player.children.length; i++) {
                  let o = _o2.player.children[i];
                  if (o.type.indexOf("Mesh") != -1) {
                    o.geometry.dispose();
                    o.material.dispose();
                    break;
                  }
                }
                _o2.scene.remove(_o2.player);
                let url = _o2.char_urls[role_id];
                let promise = _o2.import_object_url(url);
                promise.then((obj3) => {
                  if (obj3) {
                    _o2.renew_all_uuid(obj3);
                    _o2.scene.add(obj3);
                    _o2.player = obj3;
                    _o2.add_lable_to_char(_o2.player, player_name);
                    //_o2.add_video_stream_to_char(obj3,player_name)
                    if (obj3.type == "Group") {
                      _o2.char = obj3;
                    } else {
                      for (let i = 0; i < obj3.children.length; i++) {
                        if (obj3.children[i].type == "Group") {
                          _o2.char = obj3.children[i];
                          break;
                        }
                      }
                    }
                    if (_o2.init_play) _o2.init_play();
                  }
                });
                //}
              }
              var str = player_name;
              var base = new Base64();
              var result = base.encode(str);
              ws.send("login," + result + "," + room_id.toString() + "," + role_id);
              console.log("login," + result + "," + room_id.toString() + "," + role_id);
              bLoginSuccess = true;
            }
            if (cmd == "new_player") {
              let pos2 = param.indexOf(",");

              var list = received_msg.split(",");
              var num;
              console.log(list);
              if (list.length > 3) {
                num = list[3];
              } else {
                num = role_id;
              }

              if (pos2 > 0) {
                let new_player_id = param.substr(0, pos2);
                let new_player_name = list[2];

                // let new_player_name = param.substr(pos2 + 1, param.length - pos2 - 1);
                //console.log(new_player_id,new_player_name);
                add_player(parseInt(new_player_id), new_player_name, num);
              }
            }
            if (cmd == "player_quit") {
              let player_id = parseInt(param);
              remove_player(player_id);
              Bus.$emit("num", -1);
            }
            if (cmd == "pos") {
              let pos2 = param.indexOf(",");
              let left = param;
              if (pos2 > 0) {
                console.log(left);
                let strid = left.substr(0, pos2);
                let id_player = parseInt(strid);
                left = left.substr(pos2 + 1, left.length - pos2 - 1);
                pos2 = left.indexOf(",");
                if (pos2 > 0) {
                  let posx = parseInt(left.substr(0, pos2));
                  left = left.substr(pos2 + 1, left.length - pos2 - 1);
                  pos2 = left.indexOf(",");
                  if (pos2 > 0) {
                    let posy = parseInt(left.substr(0, pos2));
                    left = left.substr(pos2 + 1, left.length - pos2 - 1);
                    let angle = parseInt(left);
                    // console.log(id_player,posx,posy,angle);
                    update_player_position(id_player, posx, posy, angle);
                  }
                }
              }
            }

            ///用户参数定义
            if (cmd.substr(0, 2) == "u_") {
              //用户消息
              let pos2 = param.indexOf(",");
              if (pos2 > 0) {
                let cmd2 = param.substr(0, pos2);
                param = param.substr(pos2 + 1, param.length - pos2 - 1);
                console.log(cmd2, param);
                if (cmd2 == "state") {
                  let state = JSON.parse(param);
                  on_ws_state(state);
                } else if (cmd2 == "cam") {
                  setView(param);
                } else if (cmd2 == "click") {
                  on_ws_click(param);
                } else if (cmd2 == "share_view") {
                  let bl = true;
                  if (param == "false") bl = false;
                  that.bAdminView = bl;
                  Bus.$emit("share_view", true);
                } else {
                  if (that.bAdminView) {
                    Bus.$emit("change", cmd2, param);
                  }
                }
              }
            }
          }
        };
        ws.onclose = function () {
          console.log("WebSocket closed...");
        };
      } else {
        console.log("NO support WebSocket!");
      }
    }
    var role_id;
    function login(name, rid, roleId, videoId) {
      ws = new WebSocket("wss://o2vr.net:9103");
      player_name = name;
      if (name.substr(0, 6) == "admin_") {
        admin_mode = true;
        player_name = player_name.substr(6, 100);
      }
      room_id = rid;
      role_id = roleId;
      WebSocketInit();
      // var tex = _o2.create_video_stream_tex(videoId);
      // _o2.add_video_stream_to_char(tex)
    }
    _o2.login = login;
    function move_player_position(player, time_passed) {
      let dst = player.target.clone();
      let clip_name = "idle";
      dst.y = ground_height;
      dst.sub(player.object.position);
      let len = dst.length();
      if (len > 1) {
        clip_name = "walk";
      }
      if (len <= 3000 * time_passed) {
        player.object.position.set(player.target.x, ground_height, player.target.z);
      } else {
        dst.y = 0;
        dst.normalize();
        dst.multiplyScalar(3000 * time_passed);
        player.object.position.add(dst);
      }
      //角度
      let angle = player.target.y;
      let current = player.object.rotation._y;
      let dst2 = (angle * 180) / 3.1415 - (current * 180) / 3.1415;
      if (Math.abs(dst2) > 180) {
        if (dst2 < 0) current = current - 3.1415 * 2;
        else current = current + 3.1415 * 2;
      }
      current = current * 0.9 + angle * 0.1;
      player.object.rotation.set(0, current, 0);
      //动作
      if (player.last_clip_name != clip_name) {
        if (!player.cold_down) player.cold_down = 1;
        player.cold_down = -1;
        if (player.cold_down <= 0) {
          console.log(player.cold_down, clip_name);
          _o2.play_skeleton_clip(player.char, clip_name, true);
          player.last_clip_name = clip_name;
          player.cold_down = 1000;
        }
      }
    }
    function update_scene_with_state(time_passed) {
      //案例墙
      if (scene_state.show_case && scene_state.show_case > 0) {
        if (projects_parent) projects_parent.visible = true;
        if (_o2.case_wall_appear) {
          _o2.case_wall_appear.LoopType = 0;
          _o2.case_wall_appear.rate = 1;
          _o2.case_wall_appear.play();
        }
      } else {
        if (projects_parent) projects_parent.visible = false;
        if (_o2.case_wall_appear) {
          _o2.case_wall_appear.LoopType = 2;
          _o2.case_wall_appear.rate = 4;
          _o2.case_wall_appear.play();
        }
      }
      //案例墙的案例移动
      if (scene_state.show_case != null) {
        let timenow = Date.now();
        let dt = Math.ceil((timenow - scene_state.show_case) / 2);
        dt = dt - 2000;
        for (let i = 0; i < project_objects.length; i++) {
          let obj = project_objects[i];
          obj.position.y = dt + obj.basey;
          if (obj.position.y > 2000 * (project_objects.length - 1)) {
            obj.position.y =
              ((obj.position.y + 2000) % (2000 * project_objects.length)) - 2000;
          }

          //if (obj.position.y>1600*(project_objects.length-1)) obj.position.y=obj.position.y-1600*project_objects.length;
        }
      }
      //当前案例
      if (scene_state.case_id != null) {
        if (last_case_id != scene_state.case_id) {
          //有改变
          if (scene_state.case_id > 0) {
            let object = project_objects[scene_state.case_id - 1];
            if (object) {
              _o2.case_screen.material.map = object.material.map;
              _o2.case_screen.case = object.case;
            }
            _o2.case_appear.current_time = 0;
            _o2.case_appear.LoopType = 0;
            _o2.case_appear.play();
          } else {
            _o2.case_appear.LoopType = 2;
            _o2.case_appear.play();
          }
          last_case_id = scene_state.case_id;
        }
      }
      //软件状态
      if (scene_state.software != null) {
        _o2.software1.LoopType = 2;
        _o2.software2.LoopType = 2;
        _o2.software3.LoopType = 2;
        _o2.software4.LoopType = 2;
        if (scene_state.software == 1) _o2.software1.LoopType = 0;
        if (scene_state.software == 2) _o2.software2.LoopType = 0;
        if (scene_state.software == 3) _o2.software3.LoopType = 0;
        if (scene_state.software == 4) _o2.software4.LoopType = 0;
        _o2.software1.play();
        _o2.software2.play();
        _o2.software3.play();
        _o2.software4.play();
      }
      //软件状态
      if (scene_state.solution != null) {
        _o2.military_appear.LoopType = 2;
        _o2.military_appear.rate = 4;
        _o2.dt_appear.LoopType = 2;
        _o2.dt_appear.rate = 4;
        _o2.home_appear.LoopType = 2;
        _o2.home_appear.rate = 4;
        _o2.edu_appear.LoopType = 2;
        _o2.edu_appear.rate = 4;
        _o2.earth_core.LoopType = 2;
        if (scene_state.solution == 1) {
          _o2.military_appear.LoopType = 0;
          _o2.military_appear.rate = 1;
        }
        if (scene_state.solution == 2) {
          _o2.edu_appear.LoopType = 0;
          _o2.edu_appear.rate = 1;
          _o2.edu_loop.play();
        } else {
          _o2.edu_loop.stop();
        }
        if (scene_state.solution == 3) {
          _o2.home_appear.LoopType = 0;
          _o2.home_appear.rate = 1;
        }
        if (scene_state.solution == 4) {
          _o2.dt_appear.LoopType = 0;
          _o2.dt_appear.rate = 1;
        }
        if (scene_state.earth_open) {
          _o2.earth_core.LoopType = 0;
        }
        _o2.home_appear.play();
        _o2.dt_appear.play();
        _o2.edu_appear.play();
        _o2.military_appear.play();
        _o2.earth_core.play();
      }

      //大屏幕视频
      {
        let obj = _o2.screen;
        if (obj && old_screen_url != scene_state.screen_url) {
          if (scene_state.screen_url == null) {
            _o2.stop_video_tex();
            obj.visible = false;
          } else {
            let bPicture = false;
            let pos = scene_state.screen_url.indexOf("?");
            if (pos > 3) {
              let ext = scene_state.screen_url.substr(pos - 3, 3);
              console.log(ext);
              ext = ext.toLowerCase();
              if (ext == "jpg" || ext == "bmp" || ext == "png" || ext == "tga") {
                bPicture = true;
              }
            }
            if (!bPicture) {
              if (old_screen_url != scene_state.screen_url) {
                if (that.ios) {
                  that
                    .$confirm("即将播放视频?", "提示", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "success",
                    })
                    .then(() => {
                      that.$message({
                        type: "success",
                        message: "开始播放",
                      });
                      obj.visible = true;
                      obj.material.map = _o2.get_video_tex(scene_state.screen_url, true);
                    })
                    .catch(() => {
                      that.$message({
                        type: "info",
                        message: "已取消删除",
                      });
                    });
                } else {
                  obj.visible = true;
                  obj.material.map = _o2.get_video_tex(scene_state.screen_url, true);
                }
              }
            } else {
              let map = _o2.create_map(scene_state.screen_url);
              obj.visible = true;
              obj.material.map = map;
            }
          }

          old_screen_url = scene_state.screen_url;
        }
      }
    }
    function screen_url(url) {
      scene_state.screen_url = url;
      on_scene_state_changed();
    }
    _o2.screen_url = screen_url;
    function frame_move(time_passed) {
      if (moveDir != 0) {
        viewHeight += moveDir.y * time_passed;
        moveDir.y = 0;
      }
      update_scene_with_state(time_passed);
      //处理 click
      {
        if (_o2.click && _o2.click.visible) {
          _o2.click.click_life -= time_passed;
          if (_o2.click.click_life < 0) {
            _o2.click.visible = false;
          }
        }
      }
      let movedir = moveDir.clone();
      let target = posPlayer.clone();
      if (_o2.player) {
        if (movedir.length() <= 0.001) {
          movedir.set(0, 0, -1);
        }
        let dir = new THREE.Vector3();
        dir.set(0, 0, 0);
        dir.applyMatrix4(_o2.camera.matrixWorld);
        movedir.applyMatrix4(_o2.camera.matrixWorld);
        movedir.sub(dir);
        movedir.y = 0;
        movedir.normalize();
      }
      let clip_name = "idle";
      if (_o2.players) {
        //更新多人在线其他角色位置
        for (let i = 0; i < _o2.players.length; i++) {
          let player = _o2.players[i];
          move_player_position(player, time_passed);
        }
      }
      if (that.bAdminView && !admin_mode) {
        //管理员控制视角
        if (_o2.players_object) _o2.players_object.visible = false;
        let tmnow = Date.now();
        let passed = tmnow - admin_move_time;

        let pos = admin_target_pos.clone();
        let eye = admin_target_eye.clone();
        let angle = admin_angle_new;
        if (passed < 500) {
          let alpha = passed / 500;
          pos = admin_old_pos.clone();
          eye = admin_old_eye.clone();
          pos.lerp(admin_target_pos, alpha);
          eye.lerp(admin_target_eye, alpha);
          posPlayer.set(pos.x, pos.y, pos.z);
          _o2.camera.position.set(eye.x, eye.y, eye.z);
          _o2.cameraControls.target.set(pos.x, pos.y + viewHeight, pos.z);
          angle = admin_angle_new * alpha + admin_angle_old * (1 - alpha);
        }

        if (_o2.player) {
          //更新角色和相机位置到posPlayer
          _o2.player.position.set(posPlayer.x, posPlayer.y, posPlayer.z);
        }

        if (!last_walk) last_walk = posPlayer.clone();
        else {
          last_walk.sub(posPlayer);
          let dst = last_walk.length();
          if (dst > 1) clip_name = "walk";
          last_walk = posPlayer.clone();
        }
        //朝向和动作
        if (_o2.player) {
          _o2.player.rotation.set(0, angle, 0);
          if (last_clip_name != clip_name) {
            _o2.play_skeleton_clip(_o2.char, clip_name, true);
            last_clip_name = clip_name;
          }
        }
        return;
      } else {
        if (_o2.players_object) _o2.players_object.visible = true;
      }

      if (!bCtrlStop) {
        if (bAutoMove) {
          clip_name = "walk";
          //先自动移动
          let dst = targetAutoMove.clone();
          dst.sub(posPlayer);
          let len = dst.length();
          if (len <= moveSpd * time_passed) {
            bAutoMove = false;
            target = targetAutoMove.clone();
          } else {
            dst.normalize();
            movedir.set(dst.x, dst.y, dst.z);
            dst.multiplyScalar(moveSpd * time_passed);
            target = posPlayer.clone();
            target.add(dst);
          }
        } else if (bKeyCtrl) {
          //然后键盘控制
          let move = moveDir.clone();
          move.normalize();
          let len = move.length();
          if (len > 0.01) {
            clip_name = "walk";
            let dir = new THREE.Vector3();
            dir.set(0, 0, 0);
            dir.applyMatrix4(_o2.camera.matrixWorld);
            move.applyMatrix4(_o2.camera.matrixWorld);
            move.sub(dir);
            move.y = 0;
            move.normalize();
            move.multiplyScalar(time_passed * moveSpd);
            target = posPlayer.clone();
            target.add(move);
          }
        }

        move_with_colli(target, time_passed);

        if (_o2.player) {
          //更新角色和相机位置到posPlayer
          let oldtarget = _o2.cameraControls.target.clone();
          let dir = _o2.camera.position.clone();
          dir.sub(oldtarget);
          let neweye = posPlayer.clone();
          neweye.add(dir);
          _o2.player.position.set(posPlayer.x, posPlayer.y, posPlayer.z);
          _o2.camera.position.set(neweye.x, neweye.y + viewHeight, neweye.z);
          _o2.cameraControls.target.set(
            posPlayer.x,
            posPlayer.y + viewHeight,
            posPlayer.z
          );
        }

        ws_pos_cold_down = ws_pos_cold_down - time_passed;
        if (ws_pos_cold_down < 0) {
          ws_pos_cold_down = 0.5;
          if (admin_mode) send_camera_to_server();
          send_position_to_server();
        }

        //朝向
        if (_o2.player) {
          let angle = Math.asin(movedir.x);
          if (movedir.z < 0) angle = 3.1415 - angle;
          target_angle = angle;
          let current = _o2.player.rotation._y;
          let dst = (target_angle * 180) / 3.1415 - (current * 180) / 3.1415;
          if (Math.abs(dst) > 180) {
            if (dst < 0) current = current - 3.1415 * 2;
            else current = current + 3.1415 * 2;
          }
          current = current * 0.9 + target_angle * 0.1;
          _o2.player.rotation.set(0, current, 0);
          if (last_clip_name != clip_name) {
            _o2.play_skeleton_clip(_o2.char, clip_name, true);
            last_clip_name = clip_name;
          }
        }
      }
    }
    function onSwitchCameraFinish(x, y, z, xx, yy, zz) {
      if (_o2.player) {
        bCtrlStop = false;
        bKeyCtrl = true;
        bAutoMove = false;
        _o2.player.position.set(x, 0, z);
        posPlayer.x = _o2.player.position.x;
        posPlayer.y = _o2.player.position.y;
        posPlayer.z = _o2.player.position.z;
        let dir = new THREE.Vector3();
        dir.x = x - xx;
        dir.y = 0;
        dir.z = z - zz;
        dir = moveDir.normalize();
        let angle = Math.atan2(dir.z, dir.x);
        angle = (angle / 3.1415) * 180;
        send_transfer_position_to_server(angle);
      }
    }
    function send_transfer_position_to_server(angle) {
      // if (!ws || !bLoginSuccess) return;
      // let str =
      //   "transfer," +
      //   Math.ceil(posPlayer.x) +
      //   "," +
      //   Math.ceil(posPlayer.z) +
      //   "," +
      //   Math.ceil(angle);
      // if (str != last_pos_send) {
      //   console.log(str);
      //   last_pos_send = str;
      //   ws.send(str);
      // }
    }
    function onKeyDown(e) {
      if (bCtrlStop) return;
      switch (e.key) {
        case "q":
        case "Q":
          moveDir.y = moveSpd;
          bAutoMove = false;
          break;
        case "e":
        case "E":
          moveDir.y = -moveSpd;
          bAutoMove = false;
          break;
        case "w":
        case "W":
          moveDir.z = -moveSpd;
          bAutoMove = false;
          break;
        case "a":
        case "A":
          moveDir.x = -moveSpd;
          bAutoMove = false;
          break;
        case "s":
        case "S":
          moveDir.z = moveSpd;
          bAutoMove = false;
          break;
        case "d":
        case "D":
          moveDir.x = moveSpd;
          bAutoMove = false;
          break;
      }
      if (document.o2) {
        document.o2.translate_camera(moveDir.x, moveDir.y, moveDir.z);
      }
    }

    Bus.$on("key", (target) => {
      switch (target) {
        case "q":
        case "Q":
          moveDir.y = moveSpd;
          bAutoMove = false;
          break;
        case "e":
        case "E":
          moveDir.y = -moveSpd;
          bAutoMove = false;
          break;
        case "w":
        case "W":
          moveDir.z = -moveSpd;
          bAutoMove = false;
          break;
        case "a":
        case "A":
          moveDir.x = -moveSpd;
          bAutoMove = false;
          break;
        case "s":
        case "S":
          moveDir.z = moveSpd;
          bAutoMove = false;
          break;
        case "d":
        case "D":
          moveDir.x = moveSpd;
          bAutoMove = false;
          break;
        case "all":
          moveDir.y = 0;
          moveDir.x = 0;
          moveDir.z = 0;
          break;
      }
      if (document.o2) {
        document.o2.translate_camera(moveDir.x, moveDir.y, moveDir.z);
      }
    });
    function onKeyUp(e) {
      if (bCtrlStop) return;
      switch (e.key) {
        case "q":
        case "Q":
          moveDir.y = 0;
          break;
        case "e":
        case "E":
          moveDir.y = 0;
          break;
        case "w":
        case "W":
          moveDir.z = 0;
          break;
        case "a":
        case "A":
          moveDir.x = 0;
          break;
        case "s":
        case "S":
          moveDir.z = 0;
          break;
        case "d":
        case "D":
          moveDir.x = 0;
          break;
      }
      if (document.o2) {
        document.o2.translate_camera(moveDir.x, moveDir.y, moveDir.z);
      }
    }

    function adminClick(a, b) {
      console.log(a, b);
      if ((a == "change", b == "4")) {
        console.log("案例展示");
        if (scene_state.show_case) {
          scene_state.show_case = 0;
          scene_state.case_id = 0;
          on_scene_state_changed();
        } else {
          scene_state.show_case = Date.now();
          on_scene_state_changed();
        }
      }
      // if (admin_mode) {
      //   ws.send(`${a},${b}`);
      // }
    }
    _o2.adminClick = adminClick;
    function active_solution(name) {
      console.log(admin_mode);
      if (admin_mode) {
        ws.send(`admin,${name}`);
      }
      let solution = 0;
      if (name == "军工") solution = 1;
      if (name == "教育") solution = 2;
      if (name == "家装") solution = 3;
      if (name == "数字孪生") solution = 4;

      scene_state.solution = solution;
      if (scene_state.solution != 2) {
        scene_state.earth_open = false;
      }
      on_scene_state_changed();
      // if (_o2.current_solution==name) return;
      // console.log("active_solution",name);
      //   //先消失
      //   if (_o2.current_solution!="")
      //   {
      //       if (_o2.current_solution=="军工")
      //       {
      //         if (_o2.military_appear)
      //         {
      //           _o2.military_appear.LoopType=2;
      //           _o2.military_appear.rate=4;
      //           _o2.military_appear.play();
      //         }
      //       }
      //       if (_o2.current_solution=="教育")
      //       {
      //           _o2.earth_core.update(0);
      //           _o2.earth_core.stop();
      //           _o2.edu_appear.LoopType=2;
      //           _o2.edu_appear.rate=4;
      //           _o2.edu_appear.play();
      //       }
      //       if (_o2.current_solution=="家装")
      //       {
      //           _o2.home_appear.LoopType=2;
      //           _o2.home_appear.rate=4;
      //           _o2.home_appear.play();
      //       }
      //   }
      //   //再出现
      //   if (name=="军工")
      //   {
      //     if (_o2.military_appear)
      //     {
      //       _o2.military_appear.LoopType=0;
      //       _o2.military_appear.rate=1;
      //       _o2.military_appear.current_time=0;
      //       _o2.military_appear.play();
      //     }
      //   }
      //   if (name=="家装")
      //   {
      //     if (_o2.home_appear)
      //     {
      //       _o2.home_appear.LoopType=0;
      //       _o2.home_appear.rate=1;
      //       _o2.home_appear.current_time=0;
      //       _o2.home_appear.play();
      //     }
      //   }
      //   if (name=="教育")
      //   {
      //       _o2.earth_core.update(0);
      //       _o2.edu_loop.play();
      //       _o2.edu_appear.LoopType=0;
      //       _o2.edu_appear.current_time=0;
      //       _o2.edu_appear.rate=1;
      //       _o2.edu_appear.play();
      //   }
      //   _o2.current_solution=name;
    }
    _o2.active_solution = active_solution;
    // function onDoubleClick(e) {
    //   if (that.flag) return;
    //   let intersects = document.o2.ray_test(e);
    //   if (document.o2 && intersects && intersects.length > 0) {
    //     let o2 = document.o2;
    //     if (o2.onDblClick) {
    //       o2.onDoubleClick(intersects[0].object);
    //     }
    //     console.log(intersects[0].object);
    //   }
    // }
    let container = document.getElementById("container");
    //container.addEventListener("click", onClick, false);
    container.addEventListener("pointerdown", onMouseDown, false);
    container.addEventListener("pointerup", onMouseUp, false);
    container.addEventListener("touchdown", onMouseDown, false);
    container.addEventListener("touchup", onMouseUp, false);
    //container.addEventListener("mousemove", onMouseMove, false);
    //container.addEventListener("dblclick", onDoubleClick, false);
    document.addEventListener("keydown", onKeyDown, false);
    document.addEventListener("keyup", onKeyUp, false);
    document.o2.frame_move_recall.push(frame_move);
    document.o2.switch_camera_finish.push(onSwitchCameraFinish);
  },
  created() {
    this.$o2Function.createDrag();
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}
</style>
